import { ISearch, RestrictedAnalytesLookup, Search, SearchLookupData, SearchResult } from '@core/models';
import { createAction, props } from '@ngrx/store';


export const DELETE_SEARCH = '[Search] Delete Search';
export const DELETE_SEARCH_SUCCESS = '[Search] Delete Search Success';

export const LOAD_FTP_SAVED_SEARCH = '[Search] Load FTP Saved Search';
export const LOAD_FTP_SAVED_SEARCHES = '[Search] Load FTP Saved Searches';
export const LOAD_FTP_SAVED_SEARCHES_SUCCESS = '[Search] Load FTP Saved Searches Success';
export const LOAD_FTP_SEARCH_LOOKUP_DATA = '[Search] Load FTP Search Lookup Data';
export const LOAD_FTP_SEARCH_LOOKUP_DATA_SUCCESS = '[Search] Load FTP Search Lookup Data Success';
export const UNLOAD_FTP_SEARCH_LOOKUP_DATA = '[Search] Unload FTP Search Lookup Data';
export const LOAD_SAVED_SEARCH = '[Search] Load Saved Search';
export const LOAD_SAVED_SEARCHES = '[Search] Load Saved Searches';
export const LOAD_SAVED_SEARCHES_SUCCESS = '[Search] Load Saved Searches Success';

export const DELETE_SEARCH_RESULT = '[Search] Delete Search Result';
export const DELETE_SEARCH_RESULT_SUCCESS = '[Search] Delete Search Result Success';

export const LOAD_GLOBAL_LOOKUP_DATA = '[Search] Load Global Lookup Data';
export const LOAD_GLOBAL_LOOKUP_DATA_SUCCESS = '[Search] Load Global Lookup Data Success';
export const UNLOAD_GLOBAL_LOOKUP_DATA = '[Search] Unoad Global Lookup Data';
export const LOAD_RESTRICTED_ANALYTES_LOOKUP = '[Search] Load Restricted Analytes';
export const LOAD_RESTRICTED_ANALYTES_LOOKUP_SUCCESS = '[Search] Load Restricted Analytes Success';
export const LOAD_SEARCH_RESULTS = '[Search] Load Search Result';
export const LOAD_SEARCH_RESULTS_SUCCESS = '[Search] Load Search Result Success';

export const LOAD_SEARCH_LOOKUP_DATA = '[Search] Load Search Lookup Data';
export const LOAD_SEARCH_LOOKUP_DATA_SUCCESS = '[Search] Load Search Lookup Data Success';
export const UNLOAD_SEARCH_LOOKUP_DATA = '[Search] Unload Search Lookup Data';
export const SAVE_SEARCH = '[Search] Save Search';
export const SAVE_SEARCH_SUCCESS = '[Search] Save Search Success';
export const UNLOAD_SAVED_SEARCH = '[Search] Unload Saved Search';
export const UNLOAD_FTP_SAVED_SEARCH = '[Search] Unload FTP Saved Search';
export const UNLOAD_FTP_SAVED_SEARCHES = '[Search] Unload FTP Saved Searches';
export const SET_FTP_SAVED_SEARCHES_SORT_ORDER = '[Search] Set FTP Saved Searches Sort Order';
export const SET_SAVED_SEARCHES_SORT_ORDER = '[Search] Set Saved Searches Sort Order';
export const SET_SEARCH_RESULTS_SORT_ORDER = '[Search] Set Search Results Sort Order';

export const loadSavedSearches = createAction(LOAD_SAVED_SEARCHES);
export const loadSavedSearchesSuccess = createAction(LOAD_SAVED_SEARCHES_SUCCESS, props<{ payload: Search[] }>());
export const loadFTPSavedSearches = createAction(LOAD_FTP_SAVED_SEARCHES);
export const loadFTPSavedSearchesSuccess = createAction(LOAD_FTP_SAVED_SEARCHES_SUCCESS, props<{ payload: Search[] }>());

export const deleteSearch = createAction(DELETE_SEARCH, props<{ search: Search }>());
export const deleteSearchSuccess = createAction(DELETE_SEARCH_SUCCESS);

export const loadRestrictedAnalytesLookup = createAction(LOAD_RESTRICTED_ANALYTES_LOOKUP);
export const loadRestrictedAnalytesLookupSuccess = createAction(LOAD_RESTRICTED_ANALYTES_LOOKUP_SUCCESS, props<{ payload: RestrictedAnalytesLookup[] }>());
export const loadSearchResults = createAction(LOAD_SEARCH_RESULTS);
export const loadSearchResultsSuccess = createAction(LOAD_SEARCH_RESULTS_SUCCESS, props<{ payload: SearchResult[] }>());

export const deleteSearchResult = createAction(DELETE_SEARCH_RESULT, props<{ searchResult: SearchResult }>());
export const deleteSearchResultSuccess = createAction(DELETE_SEARCH_RESULT_SUCCESS, props<{ searchResult: SearchResult }>());

export const loadGlobalLookupData = createAction(LOAD_GLOBAL_LOOKUP_DATA);
export const loadGlobalLookupDataSuccess = createAction(LOAD_GLOBAL_LOOKUP_DATA_SUCCESS, props<{ payload: SearchLookupData }>());
export const unloadGlobalLookupData = createAction(UNLOAD_GLOBAL_LOOKUP_DATA);
export const loadSearchLookupData = createAction(LOAD_SEARCH_LOOKUP_DATA);
export const loadSearchLookupDataSuccess = createAction(LOAD_SEARCH_LOOKUP_DATA_SUCCESS, props<{ payload: SearchLookupData }>());
export const unloadSearchLookupData = createAction(UNLOAD_SEARCH_LOOKUP_DATA);

export const loadFTPSearchLookupData = createAction(LOAD_FTP_SEARCH_LOOKUP_DATA, props<{ orgId: string }>());
export const loadFTPSearchLookupDataSuccess = createAction(LOAD_FTP_SEARCH_LOOKUP_DATA_SUCCESS, props<{ payload: SearchLookupData }>());
export const unloadFTPSearchLookupData = createAction(UNLOAD_FTP_SEARCH_LOOKUP_DATA);

export const loadSavedSearch = createAction(LOAD_SAVED_SEARCH, props<{ payload: Search }>());

export const saveSearch = createAction(SAVE_SEARCH, props<{ search: ISearch, isFtpSearch: boolean, isSearchOptionSave?: boolean }>());
export const saveSearchSuccess = createAction(SAVE_SEARCH_SUCCESS, props<{ search: ISearch, isFtpSearch: boolean }>());
export const saveSearchFailure = createAction('[Search] Save Search Failure', props<{ err: string }>());

export const loadFTPSavedSearch = createAction(LOAD_FTP_SAVED_SEARCH, props<{ search: Search }>());

export const unloadSavedSearch = createAction("[Search] Unload FTP or Saved Search");
export const unloadSavedSearches = createAction("[Search] Unload FTP or Saved Searches");

export const setFTPSavedSearchesSortOrder = createAction(SET_FTP_SAVED_SEARCHES_SORT_ORDER, props<{ payload: string }>());
export const setSavedSearchesSortOrder = createAction(SET_SAVED_SEARCHES_SORT_ORDER, props<{ payload: string }>());
export const setSearchResultsSortOrder = createAction(SET_SEARCH_RESULTS_SORT_ORDER, props<{ payload: string }>());

export const onScheduleSavedSearch = createAction('[Search] On Schedule Save Search', props<{ search: ISearch }>());
export const onScheduleSavedSearchSuccess = createAction('[Search] On Schedule Save Search Success', props<{ search: Search }>());
export const onScheduleSavedSearchFailure = createAction('[Search] On Schedule Save Search Failure', props<{ err: string }>());

